const _faqTitle = $('.js-faqTitle');

if(_faqTitle.length){
	_faqTitle.click(function(){
		let _e = $(this);
		_e.find('.p-homeQa__questionIcon').toggleClass('is-active');
		_e.next().slideToggle();
	})
}
